import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, take } from 'rxjs';


import { ProjectsFormsService } from '@app/services/app/projects-forms.service';
import { CustomFormSubmission, CustomFormFieldSubmission, FieldDynamicUrlLinkButtonProjectContext } from '@core/objects/form';

// import { ThreeDotsMenuItem } from '@core/components/helpers/navigation/three-dots-menu/three-dots-menu-item';

@Component({
    selector: 'project-details-forms-view-main',
    templateUrl: './view-main.component.html',
    styleUrls: ['./view-main.component.scss']
})
export class ProjectDetailsFormsViewMainComponent implements OnInit  {

	public readonly STATUS_LOADING = 0;
    public readonly STATUS_DONE = 1;
    // dynamic link using project adn form
    public DYNAMIC_LINK_FIELD_TYPE = 'dynamic-url-link-button-v1';

    @Input() customForm: CustomFormSubmission;
    
	@Output() cancel = new EventEmitter<boolean>();

    public dynamicLinKButtoncontext: FieldDynamicUrlLinkButtonProjectContext;
	
    fields$: Observable<CustomFormFieldSubmission[]>;
    loadingFields$: Observable<boolean>;
    errorFields$: Observable<HttpErrorResponse>;

	constructor(private projectFormsSrv: ProjectsFormsService){}

	ngOnInit(){

        this.projectFormsSrv.selectProject().pipe(
            take(1)
        ).subscribe((projectNumber: number) => {
            this.dynamicLinKButtoncontext = {
                project: projectNumber,
                form: this.customForm.uuid
            };
        });

        this.fields$ = this.projectFormsSrv.selectFormFields(this.customForm.uuid);
        this.loadingFields$ = this.projectFormsSrv.selectLoadingFields(this.customForm.uuid);
        this.errorFields$ = this.projectFormsSrv.selectErrorFields(this.customForm.uuid);
        this.projectFormsSrv.loadFormFieldSubmissions(this.customForm.uuid);
    }

}
